import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { MessageService } from 'primeng/api';

import { PermissionLevel } from '../../shared/enum/permission-level.enum';
import { WRITING_SEGMENTS } from '../../shared/constant/permission';
import { PermissionAccessService } from '../../shared/services/permission-access.service';

@Injectable()
export class AuthorizationGuard implements CanActivateChild {
    constructor(
        private router: Router,
        private messageService: MessageService,
        private permissionAccess: PermissionAccessService,
    ) {}

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const level = this.levelRequiredBy(state.url);

        if (this.permissionAccess.canOpenRoute(route, level)) {
            return true;
        }

        this.messageService.add({
            severity: 'warn',
            summary: 'Not available',
            detail: this.permissionAccess.refusalReasonForRoute(route, level),
        });

        return this.router.parseUrl('/');
    }

    /*=====================================
      What opening this address costs.

      The same rule the API's AuthorizationGuard applies to an HTTP method, read
      off the URL instead: a form that creates or edits is a write, everything
      else - lists, view screens, the deleted list - is a read.
      @param url - the address being opened
      @return the level the caller needs to hold
    ======================================*/
    private levelRequiredBy(url: string): PermissionLevel {
        return WRITING_SEGMENTS.some((segment) => url.includes(`/${segment}`))
            ? PermissionLevel.MANAGE
            : PermissionLevel.VIEW;
    }
}
